import { useCallback } from "react";
import { tipp } from "./me/index.js";
/**
 * Sofort-Popup statt `title` (Hausregel): verbindet ein Element mit dem gemeinsamen Popup von
 * me-design (`tipp`). Ein leerer Text schaltet das Popup für das Element stumm.
 */
export function useSofortPopup(text) {
    return useCallback((element) => {
        if (element !== null)
            tipp(element, text);
    }, [text]);
}
//# sourceMappingURL=sofortPopup.js.map